export default {
    upsert: {
        load: 'COMPANY_UPSERT_LOAD',
        success: 'COMPANY_UPSERT_SUCCESS',
        error: 'COMPANY_UPSERT_ERROR',
    },
};
